import { Fragment } from 'react'
import { useCanHover } from '../app/useViewport'
import type { OnIt } from './activity'
import { displayName } from './format'
import { newTabFor, openLink } from './openLink'

/**
 * "Clara is on it" under the last message of a room or a thread, or "Clara
 * asked for a permission" with a way to the session for its owner, who is the
 * one who can answer the prompt. Several agents share the line.
 */
export function OnItLine({ onIt, ownsAgent }: {
  onIt: OnIt[]
  ownsAgent?: (name: string) => boolean
}) {
  const canHover = useCanHover()
  if (!onIt.length) return null
  return (
    <p role="status" style={{ margin: 0, padding: '6px 2px 12px', fontSize: 12.5, color: 'var(--text-soft)' }}>
      {onIt.map(({ agent, activity }, index) => {
        const link = activity === 'blocked' && ownsAgent?.(agent.name) ? openLink(agent, canHover) : null
        return (
          <Fragment key={agent.name}>
            {index > 0 && (index === onIt.length - 1 ? ' and ' : ', ')}
            <span style={{ fontWeight: 600, color: 'var(--text)' }}>{displayName(agent.name, agent.nickname)}</span>
            {activity === 'blocked' ? ' asked for a permission' : ' is on it'}
            {link && <> (<a href={link} {...newTabFor(link)} style={{ color: 'inherit' }}>open it</a>)</>}
          </Fragment>
        )
      })}
      {/* The reduced-motion rule in tokens.css stops the pulse, so the dots stand still. */}
      <span aria-hidden="true">
        {[0, 1, 2].map((dot) => (
          <span key={dot} style={{ animation: `sp-pulse 1.4s ease-in-out ${dot * 0.2}s infinite` }}>.</span>
        ))}
      </span>
    </p>
  )
}
